const productDivs = document.querySelectorAll('.desctop-menu-large .tt-desktop-header .tt-obj-menu .tt-desctop-menu .megamenu .tt-col-list .col-sm-4');
const productImg = document.querySelectorAll('.desctop-menu-large .tt-desktop-header .tt-obj-menu .tt-desctop-menu .megamenu .header-menu-product .tt-product .tt-image-box .tt-img img');
const defaultImg = "//skateboardselectric.com/cdn/shop/files/Beginner_Electric_Skateboards_image_400x.png?v=1697712086";

productDivs.forEach((div) => {
            div.addEventListener('mouseover', function () {
                const img = div.querySelector('img');
                const imgSrc = img.getAttribute('src');
                console.log('Image source:', imgSrc);
                productImg[0].setAttribute('src', imgSrc);
            });
        });

productDivs.forEach((div) => {
            div.addEventListener('mouseout', function () {
                productImg[0].setAttribute('src', defaultImg);
            });
        });